
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/recruit",
      function () {
        return require("private-next-pages/recruit/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/recruit"])
      });
    }
  